import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.11 4.165C10.755 3.977 12.75 4 12.75 4s.477-.024 3.14.164a3.18 3.18 0 0 1 2.944 2.894A47 47 0 0 1 19 11.156c0 1.517-.058 4.469-.174 5.855a3.18 3.18 0 0 1-3.17 2.917H8.344a3.18 3.18 0 0 1-3.17-2.917C5.058 15.625 5 12.673 5 11.156q0-2.225.166-4.098A3.18 3.18 0 0 1 8.11 4.165m.064.907a2.27 2.27 0 0 0-2.103 2.066 46 46 0 0 0-.162 4.018c0 1.492.057 4.42.17 5.78a2.273 2.273 0 0 0 2.265 2.083h7.312a2.273 2.273 0 0 0 2.264-2.083c.114-1.36.17-4.288.17-5.78q0-2.186-.161-4.017a2.27 2.27 0 0 0-2.104-2.067c-2.642-.187-3.075-.121-3.075-.121s-1.95-.066-4.576.12",
      clipRule: "evenodd"
    }
  )
);
var SvgControlStopOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ControlStopOutlined_default = SvgControlStopOutlined;

export { ControlStopOutlined_default as default };
